import React from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { Footer } from '@src/common/Footer';
import { styled } from '@uhg-abyss/web/tools/styled';
import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { NewHeader } from '@src/common/NewHeader';

const Body = styled('div', {
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',

  '@media print': {
    minHeight: 0,
    height: '100%',
  },
});
export const App = () => {
  return (
    <Body>
      <NewHeader />
      <PageBody
        css={{
          'abyss-page-body-root': {
            background: 'rgb(244, 244, 244)',
            paddingBottom: '128px',
          },
        }}
      >
        <Router.Outlet />
      </PageBody>
      <Footer />
    </Body>
  );
};
